<template>
  <!-- scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-600 scrollbar-track-gray-900 dark:scrollbar-track-gray-800 dark:bg-gray-900 overflow-auto -->
  <aside v-show="!isFullScreen"
    class="w-64 h-screen fixed top-0 bg-white dark:bg-gray-900 transition-all sidebar-parent" :class="[
      !isAsideMobileExpanded ? 'sidebar-parent-open' : '',
      isAsideLgActive ? 'block' : 'lg:block'
    ]" style="transition: left 1s; z-index: 10;">

    <!-- isAsideMobileExpanded ? '-left-64' : 'left-0', -->
    <div class="inner-sidebar">
      <div class="bg-top-sidebar transition-colors duration-1000" :class="darkMode ? 'bg-gray-400' : 'bg-white'">
        <div class="container-logo w-full h-auto">
          <!-- <show-image :imageName="schoolidentity.img" /> -->
          <img class="mx-auto h-10 w-auto" v-if="schoolidentity.img" :src="schoolidentity.img" alt="Status No Aktif">
        </div>

        <div class="container-company w-full h-auto p-2 mt-4 transition-colors duration-1000"
          :class="darkMode ? 'bg-gray-400' : 'bg-sch-name'">
          <div class="school-sidebar transition-colors  duration-1000"
            :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'">
            <!-- <div class="img-sch">
              <img src="../assets/kanisius/cc.png" alt="School">
            </div> -->
            <div class="name-sch">
              <!-- SCHOOL NAME -->
              {{ schoolidentity.name }}
            </div>

          </div>

          <control class="dark:border-gray-900 transition-colors duration-1000"
            style="margin-top: 10px; background-color: white !important;"
            v-model="filter.branch_id"
            :options="branchList"
            @change="reloadWeb()"
            v-if="filter.branch_id && filter.branch_id != ''"
          />
        </div>
      </div>

      <div class="button-close-aside" :class="{ 'button-show-aside': isAsideMobileExpanded }"
        @click.prevent="menuToggleMobile">
        <icon :path="mdiBackburger" :w="'w-6'" :h="'h-6'" />
      </div>

      <div class="menu-sidebar transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'">
        <template v-for="(menuGroup, index) in menu">
          <p v-if="typeof menuGroup === 'string'" :key="`a-${index}`"
            class="hidden p-3 text-xs uppercase text-gray-800">{{ menuGroup }}</p>
          <aside-menu-list v-else :key="`b-${index}`" :menu="menuGroup" @menu-click="menuClick" />
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
/* eslint-disable */
import axios from "axios"
import { computed, ref, onMounted, reactive } from "vue"
import { useStore } from "vuex"
import { useToast } from "vue-toastification"
import { mdiMenu, mdiForwardburger, mdiBackburger } from "@mdi/js"
import AsideMenuList from "@/components/AsideMenuList"
import Control from "@/components/Control"
import Icon from "@/components/Icon"
import { getBranchData } from "@/composables/global"
import { useBranchManager } from "@/composables/useBranchManager"

export default {
  name: "AsideMenu",
  components: {
    AsideMenuList,
    Control,
    Icon,
  },
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const store = useStore()
    const toast = useToast()

    const isFullScreen = computed(() => store.state.isFullScreen)
    const isAsideMobileExpanded = computed(
      () => store.state.isAsideMobileExpanded
    )
    const isAsideLgActive = computed(() => store.state.isAsideLgActive)
    const menuToggleMobile = () => store.dispatch("asideMobileToggle")

    const { selectedBranchId, branchList, BranchDataList } =
      useBranchManager(getBranchData)

    const filter = reactive({
      get branch_id() {
        return selectedBranchId.value
      },
      set branch_id(val) {
        selectedBranchId.value = val
      },
    })

    const schoolidentity = reactive({
      id: "",
      name: "",
      website_url: "",
      email: "",
      address1: "",
      address2: "",
      address3: "",
      address4: "",
      telp1: "",
      telp2: "",
      telp3: "",
      telp4: "",
      fax1: "",
      fax2: "",
      description: "",
      file_name: "",
      status: "",
      library: "",
      info1: "",
      info2: "",
      info3: "",
      created_by: "",
      updated_by: "",
    })

    const getData = async () => {
      try {
        const { data } = await axios.get("/get-menu")
        Object.assign(schoolidentity, data.data)
      } catch (error) {
        console.error(error)
      }
    }

    onMounted(() => {
      getData()
    })

    const reloadWeb = () => {
      window.location.reload()
    }

    const menuClick = (event, item) => {
      // handle menu click
    }

    const darkMode = computed(() => store.state.darkMode)

    return {
      reloadWeb,
      filter,
      branchList,
      BranchDataList,
      darkMode,
      isFullScreen,
      isAsideMobileExpanded,
      menuToggleMobile,
      isAsideLgActive,
      menuClick,
      mdiMenu,
      mdiForwardburger,
      mdiBackburger,
      schoolidentity,
    }
  },
}
</script>
